// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "-" + "2c4ce6b2bfa50641585e" + ".css";
};